"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = "\n  image\n  name\n  url\n  cid\n  parentName\n  trackingToken\n  includedInCategories\n";
//# sourceMappingURL=brandData.js.map